<template>
  <div class="activity-coupon">
    <div class="content-wrapper">
      <div class="explain">
        <h2 class="title">{{$t("m.act_c_explain1")}}</h2>
        <ul>
          <li>{{$t("m.act_c_explain2")}}</li>
          <li>{{$t("m.act_c_explain3")}}</li>
          <li>{{$t("m.act_c_explain4")}}</li>
        </ul>
        <button class="add-coupon" @click="showAddCoupon">{{$t("m.act_c_addcoupon")}}</button>
      </div>
      <div class="list-out-wrapper">
        <el-tabs type="card" v-model="activeName" @tab-click="handleClick" class="nav-hooker">
          <el-tab-pane :label="$t('m.act_c_ongoing')" name="first"></el-tab-pane>
          <el-tab-pane :label="$t('m.act_c_history')" name="second"></el-tab-pane>
        </el-tabs>
        <div class="list-in-wrapper" v-if="!isEmpty(list)">
          <template v-for="(item,index) in list">
            <div class="list">
              <div class="left">
                <p class="title">
                  <template v-if="item.isClass">
                    <span class="icon class">班</span>
                    <span class="text">{{$t("m.act_c_class_coupon")}}</span>
                  </template>
                  <template v-else-if="item.isLesson">
                    <span class="icon lesson">课</span>
                    <span class="text">{{$t("m.act_c_course_coupon")}}</span>
                  </template>
                  <template v-else-if="item.isSchool">
                    <span class="icon school">校</span>
                    <span class="text">{{$t("m.act_c_school_coupon")}}</span>
                  </template>
                  <span class="text">{{item.discountmoney}}{{$t("m.act_c_yuan")}}</span>
                </p>
                <p class="time">
                  {{$t("m.act_c_creattime")}}{{item.addtime}}
                </p>
                <p class="introduce">
                  <template v-if="item.isClass">
                    {{$t("m.act_c_coupon_class_explain1")}}《{{decodeURIComponent(item.lessonname)}}》{{$t("m.act_c_coupon_class_explain2")}}《{{decodeURIComponent(item.classname)}}》{{$t("m.act_c_coupon_class_explain3")}}
                  </template>
                  <template v-else-if="item.isLesson">
                    {{$t("m.act_c_coupon_course_explain1")}}《{{decodeURIComponent(item.lessonname)}}》{{$t("m.act_c_coupon_course_explain2")}}
                  </template>
                  <template v-else-if="item.isSchool">
                    {{$t("m.act_c_coupon_school_explain")}}
                  </template>
                </p>
              </div>
              <div class="right">
                <p class="row">{{$t("m.act_c_total_quantity")}}{{item.totalnumber}}{{$t("m.act_c_total_ticket")}}</p>
                <p class="row">{{$t("m.act_c_receive")}}{{item.userownnumber}}{{$t("m.act_c_total_ticket")}}</p>
                <p class="row">{{$t("m.act_c_deadline")}}{{item.deadline}}</p>
              </div>
              <div class="share-wrapper">
                <button class="share" @click="showQR(item.discountcodeid)">{{$t("m.act_c_share")}}</button>
              </div>
            </div>
          </template>
          <template v-if="totoalPage>10">
            <el-pagination
              background
              layout="prev, pager, next"
              :current-page.sync="currentPage"
              @current-change="handleCurrentChange"
              :page-size="10"
              :total="totoalPage">
            </el-pagination>
          </template>
        </div>

      </div>
    </div>
    <div class="couponpop-mask" v-if="newCouponShow">
      <div class="couponpop">
        <h2 class="title">{{$t("m.act_c_addcoupon")}}</h2>
        <p class="sub-title">{{$t("m.act_c_explain_school")}}</p>
        <p class="row">
          <span class="left">{{$t("m.act_c_yhje")}}</span>
          <span class="text tleft">{{$t("m.act_c_minus")}}</span>
          <input type="text"
                 :value="integer"
                 @keyup="integerChange"
                 class="input-num"
                 maxlength="4">
          <!--<input type="text"-->
                 <!--:value="integer"-->
                 <!--@keyup="integerChange"-->
                 <!--class="input-num"-->
                 <!--placeholder="填写金额"-->
                 <!--maxlength="4">-->
          <span class="text tright">{{$t("m.act_c_yuan")}}</span>
        </p>
        <p class="row">
          <span class="left">{{$t("m.act_c_number")}}</span>
          <span class="text tleft">{{$t("m.act_c_gong")}}</span>
          <input type="text"
                 :value="integer2"
                 @keyup="integerChange2"
                 class="input-num"
                 maxlength="4">
          <span class="text tright">{{$t("m.act_c_zhang")}}</span>
        </p>
        <p class="row">
          <span class="left">{{$t("m.act_c_deadline2")}}</span>
          <el-date-picker
            class="picktime"
            v-model="date"
            type="datetime"
            :picker-options="pickerOptions">
          </el-date-picker>
        </p>
        <div class="operate-btn-wrapper">
          <button class="btn cancel" @click="newCouponShow=false">{{$t("m.act_c_cancel")}}</button>
          <button class="btn confirm" @click="createCoupon">{{$t("m.act_c_confirm")}}</button>
        </div>
      </div>
    </div>
    <div class="couponpop-mask" v-if="QRCodeShow">
      <div class="couponpop">
        <img class="close" @click="hide" src="./close.png" alt="close" width="20" height="20">
        <h2 class="title">{{$t("m.act_c_share_coupon")}}</h2>
        <img :src="url" alt="QRcode" width="300" height="300">
        <p class="explain">{{$t("m.act_c_share_explain")}}</p>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        //-----------以下内容和弹出层有关------------------------//
        newCouponShow: false,
        inputInteger: '',
        inputInteger2: '',
        date: null,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now();
          }
        },
        //-----------分享的二维码--------------------//
        url: '',
        QRCodeShow: false,
        //-----------以下内容和切换列表有关------------------------//
        activeName: 'first',
        list: [],
        flat: 1,
        currentPage: 1,
        totoalPage: 1,
      }
    },
    methods: {
      isEmpty(obj){
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      showAddCoupon(){
        this.inputInteger = '';
        this.inputInteger2 = '';
        this.date = null;
        this.newCouponShow = true;
      },
      integerChange(e) {
        this.inputInteger = e.target.value;
        this.$forceUpdate()  // 这里必须有
      },
      integerChange2(e) {
        this.inputInteger2 = e.target.value;
        this.$forceUpdate()  // 这里必须有
      },
      createCoupon(){
        //上传需满足条件
        if (this.integer !== '' && this.integer2 !== '' && this.date !== null) {
          const loading = this.$loading({
            lock: true,
            text: '上传中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          let time = this.date;
          let deadline = `${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()} ${time.getHours()}:${time.getMinutes()}`;
          this.$http({
            url: '/indexapp.php',
            method: 'GET',
            params: {
              c: 'DiscountCode',
              a: 'AddDiscountCodes',
              id: this.id,
              rid: this.schoolNow.rid,
              discountmoney: this.integer,
              number: this.integer2,
              deadline: deadline,

            }
          }).then((response) => {
            response = response.data;
            if (response.code === 111) {
              this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
            }
            if (response.code === 200) {
              this.$message({
                message: '添加优惠券成功',
                type: 'success',
              });
              loading.close();
              this.QueryDiscountCodes(1, 1);
              this.currentPage = 1;
              this.activeName = 'first';
              this.newCouponShow = false;
            } else {
              this.$message({
                message: response.msg,
                type: 'warning'
              });
            }
          }).catch((err) => {
            this.$alert('请求失败，请重试', '提示', {
              confirmButtonText: '确定',
            });
            loading.close();
          })
        }

      },
      handleClick(tab, event) {
        this.currentPage = 1;
        if (tab.name === 'first') {
          this.flag = 1;
        } else if (tab.name === 'second') {
          this.flag = 2;
        }
        this.QueryDiscountCodes(this.flag, 1);
      },
      handleCurrentChange(val){
        this.QueryDiscountCodes(this.flag, val);
      },
      showQR(discountcodeid){
        this.QRCodeShow = true;
        this.url = '';
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'DiscountCode',
            a: 'GetDiscountCodeShareUrl',
            discountcodeid: discountcodeid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            let url = encodeURIComponent(response.url);
            url = encodeURIComponent(url);
            let title = '发红包啦！【全优在线】邀请您一起来上课。';
            let subtitle = '领取红包，就能上课啦~记得约上小伙伴们一起来报名哦~';
            let img = response.shareimage;
            let finalUrl = response.homepath + `indexm.html#/share?title=${title}&subtitle=${subtitle}&img=${img}&url=${url}`;
            finalUrl = encodeURIComponent(finalUrl);
            this.url = response.path + 'indexapp.php?c=QRCode&a=QRCode&url=' + finalUrl + '&size=8';
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        })
      },
      hide(){
        this.QRCodeShow = false;
      },
      //查询优惠券
      QueryDiscountCodes(flag, page){
        this.list = [];
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'DiscountCode',
            a: 'QueryDiscountCodes',
            id: this.id,
            rid: this.schoolNow.rid,
            pageno: page,
            pagesize: 10,
            count: 1,
            flag: flag
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.totoalPage = response.recordcount;
            let list = response.list;
            list.forEach(function (ele) {
              ele.isSchool = 0;
              ele.isLesson = 0;
              ele.isClass = 0;
              if (ele.classid !== 0) {
                ele.isClass = 1;
              } else if (ele.lessonid !== 0) {
                ele.isLesson = 1;
              } else {
                ele.isSchool = 1;
              }
            });
            this.list = list;
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        })
      }
    },
    computed: {
      integer() {
        return this.inputInteger.replace(/[^\d]/g, '').replace(/^0/g, "");
      },
      integer2() {
        return this.inputInteger2.replace(/[^\d]/g, '').replace(/^0/g, "");
      },
    },
    created(){
      this.QueryDiscountCodes(1, 1);
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .activity-coupon
    width: 100%
    height: 100%
    background: #f2f2f2
    font-size: 0
    overflow auto
    .content-wrapper
      margin: 111px 20px 20px 180px
      width: 1166px
      .explain
        padding: 25px 0 20px 30px
        background #fff
        .title
          font-size: 16px
          color: #555555
          font-weight: bold
        ul
          margin-top: 20px
          list-style none
          li
            font-size: 14px
            color: #888888
            line-height: 20px
        .add-coupon
          display inline-block
          margin: 40px 0 0 0
          height: 40px
          padding: 0 10px
          line-height: 40px
          font-size: 16px
          text-align: center
          color: #ffffff
          border-radius 4px
          background #3399ff
      .list-out-wrapper
        margin: 20px auto
        width: 1166px
        background #fff
        .nav-hooker
          height: 41px
          overflow hidden
        .list-in-wrapper
          border: 1px solid #e4e4e4
          border-top: none
          .list
            margin: 0 15px
            border-bottom: 1px solid #e4e4e4
            overflow hidden
            &:last-child
              border: none
            .left
              float: left
              margin: 10px 0 10px 20px
              width: 400px
              height: 122px
              border-right: 4px dashed #e4e4e4
              .title
                margin-top: 10px
                .icon
                  display inline-block
                  width: 30px
                  height: 30px
                  margin-right: 10px
                  border-radius 30px
                  line-height: 30px
                  text-align: center
                  font-size: 20px
                  color: #ffffff
                  &.class
                    background #8787ff
                  &.lesson
                    background #3399ff
                  &.school
                    background #ff978b
                .text
                  font-size: 20px
                  color: #000000
                  font-weight: bold

              .time, .introduce
                font-size: 12px
                color: #999999
                line-height: 18px
                margin-top: 12px
            .right
              float: left
              margin: 25px 0 0 60px
              width: 300px
              .row
                font-size: 13px
                color: #888888
                line-height: 20px
                margin-bottom: 12px

            .share-wrapper
              float: left
              .share
                display inline-block
                margin: 50px 0 0 30px
                width: 85px
                height: 34px
                line-height: 34px
                text-align center
                font-size: 14px
                color: #ffffff
                background #3399ff
                border-radius 4px
    .couponpop-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .couponpop
        margin: auto
        width: 420px
        padding: 30px 60px 40px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        position relative
        .close
          position absolute
          top: 20px
          right: 20px
          cursor: pointer
        .title
          line-height: 32px
          font-size: 24px
          color: #000
          font-weight: bold
        .sub-title
          margin: 10px 0 50px 0
          font-size: 12px
          color: #ff5353
          line-height: 18px
        .row
          margin-bottom: 10px
          height: 35px
          .left
            display: inline-block
            margin-right: 10px
            line-height: 35px
            width: 90px
            font-size: 15px
            color: #888
            text-align: right
          .text
            font-size: 15px
            color: #888888
            &.tleft
              margin-right: 5px
            &.tright
              margin-left: 5px
          .input-num
            width: 90px
            height: 35px
            font-size: 15px
            color: #000
            padding-left: 6px
            border: 1px solid #d7d7d7
            border-radius: 4px
            box-sizing: border-box
            &::-webkit-input-placeholder
              color: #ccc
          .picktime
            width: 200px
        .operate-btn-wrapper
          margin: 40px auto 0
          width: 225px
          .btn
            width: 80px
            height: 34px
            line-height: 34px
            font-size: 16px
            color: #ffffff
            border-radius 4px
          .cancel
            margin-right: 65px
            background #ccc
          .confirm
            background #3399ff
        .explain
          font-size: 14px
          color: #333
          line-height: 18px
</style>



// WEBPACK FOOTER //
// src/page/activity/activitycoupon/ActivityCoupon.vue